module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-319.a58543db.jpg";